export const isNumber = val => /^\d+$/.test(val)
export const pathFromField = field =>
    Number.isInteger(field)
        ? [field]
        : typeof field === "string"
        ? field.split(".").map(f => (isNumber(f) ? parseInt(f, 10) : f))
        : field
